namespace $.$$ {
	export class $yuf_number_range extends $.$yuf_number_range {
		
		override step() {
			return this.precision_change() * this.boost()
		}

	}
}
